module.exports = __webpack_public_path__ + "img/idea.a20b21c5.svg";